import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBeaker = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.99994 8.80704V3.5H7.43744C7.02323 3.5 6.68744 3.16421 6.68744 2.75C6.68744 2.33579 7.02323 2 7.43744 2H16.5624C16.9767 2 17.3124 2.33579 17.3124 2.75C17.3124 3.16421 16.9767 3.5 16.5624 3.5H15.9999V8.80704L21.125 18.1082C22.089 19.8576 20.8235 22 18.826 22H5.17391C3.17642 22 1.91084 19.8576 2.87484 18.1082L7.99994 8.80704ZM14.4999 3.5H9.49994V9C9.49994 9.12658 9.46791 9.25109 9.40682 9.36195L7.12667 13.5H16.8732L14.5931 9.36195C14.532 9.25109 14.4999 9.12658 14.4999 9V3.5ZM4.18859 18.8321L6.30014 15H17.6997L19.8113 18.8321C20.2244 19.5818 19.682 20.5 18.826 20.5H5.17391C4.31784 20.5 3.77545 19.5818 4.18859 18.8321Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgBeaker;
